import { FC } from 'react';

import { Rocket, Sparkles, Swords } from 'lucide-react';

import { FilterGlyphIcon } from './FilterGlyphIcon';

interface Props {
    readonly iconKey: string;
    readonly className?: string;
}

const ARENA_ICONS = {
    ground: Swords,
    space: Rocket,
};

const ARENA_PREFIX = 'swu_arena_';

export const StarWarsOptionIcon: FC<Props> = ({ iconKey, className }) => {
    const Icon =
        ARENA_ICONS[
            iconKey.slice(ARENA_PREFIX.length) as keyof typeof ARENA_ICONS
        ];

    return (
        <FilterGlyphIcon
            icon={Icon ?? Sparkles}
            className={className}
            containerClassName="border-slate-500/50 bg-slate-500/10 text-slate-700 dark:text-slate-200"
        />
    );
};
